import { createElement } from 'react';
import dayjs from 'dayjs';
import { RouteObject, redirect } from 'react-router-dom';

import { isHasAccess, pathPermissions, replacePermissions } from 'features/validateAccess';

import { timesheetsService, DEFAULT_TIMESHEETS_SIZE, timesheetsStore } from 'entities/timesheet';
import { pathKeys } from 'shared/lib/react-router';

import TimesheetsPage from './TimesheetsPage';

export const timesheetsPageRoute: RouteObject = {
  path: pathKeys.timesheets(),
  element: createElement(TimesheetsPage),
  loader: async (args) => {
    const [, searchParams] = args.request.url.split('?');
    const accountId = new URLSearchParams(searchParams).get('accountId') ?? '';
    const projectId = new URLSearchParams(searchParams).get('projectId') ?? '';

    const requiredPermissions = replacePermissions(pathPermissions.timesheets, {
      accountId,
      projectId,
    });

    if (!isHasAccess(requiredPermissions)) {
      return redirect(pathKeys.dashboard());
    }

    const { orders, topLevelFilters, columnFilters } = timesheetsStore.getState();

    Promise.resolve(
      timesheetsService.prefetchQuery({
        year: dayjs().year().toString(),
        month: (dayjs().month() + 1).toString(),
        size: DEFAULT_TIMESHEETS_SIZE,
        sort: orders?.[0]?.fieldName,
        order: orders?.[0]?.orderDirection,
        filters: {
          ...topLevelFilters,
          ...columnFilters,
          projectIds: projectId ? [projectId] : [],
          accountIds: !projectId && accountId ? [accountId] : undefined,
        },
      }),
    );

    return args;
  },
};
